const searchIndex = [
{
    id: "our-mission",
    title: "Our Mission",
    snippet: "To connect high school students in the South Bay with meaningful volunteer opportunities to make a difference in their communities.",
    url: "/#mission",
},
{
    id: "impact-section",
    title: "Our Community Impact",
    snippet: "5+ Volunteer Opportunities, 10+ Volunteer Hours, 5+ Student Volunteers, 1+ Partner Organizations",
    url: "/#impact",
},
{
    id: "connecting-south-bay",
    title: "Connecting South Bay Hearts Through Service.",
    snippet: "Join a growing movement of service-minded individuals and organizations making a difference in the South Bay. Whether you're looking to give your time or collaborate as a partner, your impact starts here. Become a Volunteer, Become a Partner",
    url: "/#connecting",
},
{
    id: "make-a-difference",
    title: "Make A Difference in the South Bay.",
    snippet: "Find meaningful volunteer opportunities that match your interests, skills, and schedule.",
    url: "/volunteer",
},
{
    id: "for-partners",
    title: "For Partners",
    snippet: "We’re always looking to collaborate with organizations that believe in empowering students and creating positive change in our communities. If you’re interested in partnering with us, we’d love to hear from you. Fill Out Partner Interest Form",
    url: "/partners",
},
{
    id: "our-partners",
    title: "Our Partners",
    snippet: "United States Youth Volleyball League, STEMForOthers",
    url: "/partners",
},
{
    id: "about-us",
    title: "About Us",
    snippet: "South Bay Volunteer Circle is a student-led organization committed to empowering high school students across the South Bay by connecting them with meaningful volunteer and internship opportunities. Founded in April 2025 by Trevor Griarte and Arvin Costes, students at Bishop Montgomery High School, our mission is to inspire youth to create positive change in their communities through accessible and impactful experiences.",
    url: "/about",
},
{
    id: "frequently-asked-questions",
    title: "Frequently Asked Questions",
    snippet: "Who can join South Bay Volunteer Circle | Any high school student in the South Bay area who is looking to make a positive impact in their community through volunteering or internships. How do I find opportunities? | You can browse our website for categorized volunteer and internship opportunities based on location, focus area, and major. Is there a cost to join? | No, South Bay Volunteer Circle is completely free for all students.",
    url: "/about",
},
{
    id: "contact-us",
    title: "Contact Us",
    snippet: "Have questions, ideas, or opportunities to share? We're excited to hear from you! Whether you're a student, organization, or community member, feel free to reach out to learn more about how you can get involved with the South Bay Volunteer Circle. Your Email, Your Message, Send Message",
    url: "/contact",
},
];

export default searchIndex;
